/* eslint-disable no-constructor-return */
class ModalList {
  constructor() {
    if (ModalList.instance) {
      return ModalList.instance;
    }

    this.list = [];

    // Store the instance in a static property
    ModalList.instance = this;
  }

  addModal({ callback, id }) {
    this.list.push({ callback, id });
  }

  removeModal({ id }) {
    this.list = this.list.filter((i) => i.id !== id);
  }

  getNumberOfModal() {
    return this.list.length;
  }

  triggerCallback(index) {
    this.list[index].callback();
  }
}

export default ModalList;
